import { render, staticRenderFns } from "./HasElectricalInstallationComplianceCertificate.vue?vue&type=template&id=7252bf03&"
import script from "./HasElectricalInstallationComplianceCertificate.vue?vue&type=script&lang=ts&"
export * from "./HasElectricalInstallationComplianceCertificate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports